import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export default function useUrlParamsHandler() {
    const [searchParams, setSearchParams] = useSearchParams();

    const getParams = useCallback((route: string) => {
        const opt = searchParams.get(route);
        return opt !== null ? opt : '';
    }, [searchParams]);

    const setParamsToUrl = useCallback((key: string, value: any) => {
        if (value !== 'undefined') {
            if (value) {
                searchParams.set(key, value.toString())
                setSearchParams(searchParams)
            } else {
                searchParams.delete(key)
                setSearchParams(searchParams)
            }
        }
    }, [searchParams, setSearchParams]);

    const urlProps = useMemo(() => {
        return {
            getParams: getParams,
            setParamsToUrl: setParamsToUrl
        }
    }, [getParams, setParamsToUrl])

    return urlProps;
}